import React from 'react'
import Layout from '../../Components/Layout'
import BannerGlobal from '../../Components/BannerGlobal'
import Teams from '../../Components/Teams'
import useDocumentTitle from '../../Hooks/PageTitle'

const TeamsPage = () => {
  useDocumentTitle("TRoo Web Design Agency | Teams Page")
  return (
    <Layout>
        <BannerGlobal/>
        <Teams isTeamPage = {true}/>
    </Layout>
  )
}

export default TeamsPage